// SPDX-License-Identifier: GPL-3.0-or-later
//
// Escape user / AI-supplied text for safe substitution inside Typst markup.
// Typst's "specials" are different from LaTeX — these are the chars that
// change meaning in markup mode:
//   \ * _ ` # $ < > @ [ ] ~
// In addition we escape end-of-line `=` (heading marker) and `+ -` at line
// start by neutralising leading whitespace — but those are positional, so we
// don't pre-process them here (the template author controls position).

const ESCAPES: Record<string, string> = {
  '\\': '\\\\',
  '*': '\\*',
  '_': '\\_',
  '`': '\\`',
  '#': '\\#',
  '$': '\\$',
  '<': '\\<',
  '>': '\\>',
  '@': '\\@',
  '[': '\\[',
  ']': '\\]',
  '~': '\\~',
};

const ESCAPE_RE = /[\\*_`#$<>@\[\]~]/g;

export function escapeTypst(input: string): string {
  return input.replace(ESCAPE_RE, (ch) => ESCAPES[ch] ?? ch);
}

// URLs inside `#link("...")` need only quote and backslash escaping.
const URL_ESCAPES: Record<string, string> = {
  '\\': '\\\\',
  '"': '\\"',
};
const URL_ESCAPE_RE = /[\\"]/g;

export function escapeTypstUrl(input: string): string {
  return input.replace(URL_ESCAPE_RE, (ch) => URL_ESCAPES[ch] ?? ch);
}
